import { createRouter, createWebHistory } from "vue-router";
import {
  auth,
  externalMfaSessionStatus,
  signOutUser,
  useEmulators,
} from "@/services/firebase";
import LoginView from "@/views/LoginView.vue";
import AccountSetupView from "@/views/AccountSetupView.vue";
import InvitationAcceptView from "@/views/InvitationAcceptView.vue";
import PortfolioView from "@/views/PortfolioView.vue";
import ProjectWorkspace from "@/views/ProjectWorkspace.vue";
import AdministrationView from "@/views/AdministrationView.vue";
import ProfileView from "@/views/ProfileView.vue";
import OrganizationsView from "@/views/OrganizationsView.vue";
import TemplatesView from "@/views/TemplatesView.vue";
import { useWorkspaceStore } from "@/stores/workspace";

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/login",
      name: "login",
      component: LoginView,
      meta: { public: true },
    },
    {
      path: "/account/setup",
      name: "account-setup",
      component: AccountSetupView,
      meta: { public: true },
    },
    {
      path: "/invitations/accept",
      name: "invitation-accept",
      component: InvitationAcceptView,
      meta: { public: true },
    },
    { path: "/", redirect: "/projects" },
    { path: "/projects", name: "projects", component: PortfolioView },
    {
      path: "/my-work",
      name: "my-work",
      component: PortfolioView,
      props: { myWork: true },
    },
    {
      path: "/administration",
      name: "administration",
      component: AdministrationView,
    },
    { path: "/profile", name: "profile", component: ProfileView },
    {
      path: "/organizations",
      name: "organizations",
      component: OrganizationsView,
      meta: { internalOnly: true },
    },
    { path: "/templates", name: "templates", component: TemplatesView },
    {
      path: "/projects/:projectId/:view?",
      name: "project",
      component: ProjectWorkspace,
    },
    { path: "/:pathMatch(.*)*", redirect: "/projects" },
  ],
});

router.beforeEach(async (to) => {
  if (to.meta.public) return true;
  await auth.authStateReady();
  const localProfile = useEmulators
    ? sessionStorage.getItem("planner-demo-profile")
    : null;
  if (!auth.currentUser && !localProfile)
    return { name: "login", query: { redirect: to.fullPath } };
  const mfaStatus = await externalMfaSessionStatus();
  if (
    mfaStatus === "mfa-enrollment-required" ||
    mfaStatus === "mfa-sign-in-required"
  ) {
    await signOutUser().catch(() => undefined);
    return {
      name: "login",
      query: { redirect: to.fullPath, mfa: "required" },
    };
  }
  if (to.meta.internalOnly) {
    const workspace = useWorkspaceStore();
    if (!workspace.user) await workspace.refreshFromApi();
    if (!workspace.isInternal) return { name: "projects" };
  }
  return true;
});
